import React, { useMemo } from "react"
import Table from "../../../components/Table/Table"
import { useState, useEffect } from "react"
import axios from "axios"
import { Button, LinearProgress, Box, Typography, Fade } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Filter from "../../../components/Filter/Filter"
import { useSelector } from "react-redux"
import { getFilterValues } from "../../../utils/getFilterValues"
import { logOut } from "../../../utils/logOut"
import { ConversationDetailsFilterData } from "../../../components/Filter/FilterData"
import { onChangeConversationDetailFilter } from "../../../store/filter/filterReducer"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"
import AudioFragment from "../../../utils/AudioFragment"


export default function ConversationDetails() {
    //Declaring states
    const [tableData, setTableData] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)

    const { showSnackbar } = useSnackbar();


    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const uniqueid = params.get('uniqueid');
    console.log(uniqueid);


    //Set header title
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setCurrentPage('Conversation Details'))
    }, [dispatch]);

    const filters = useSelector((state: any) => state.filter.filterUserData.conversationdetail)

    //Making a request to get data for a table
    // async function fetchData(params: object = {}) {
    //     setLoading(true)
    //     try {
    //         const response = await axios.get('https://cardgarantsales.com/restapi/transcript', {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             },
    //             params: { ...params, startRow, maxRows, calculatetotalcount: true }
    //         })
    //         if (response.data !== null) {
    //             if (typeof (response.data) === 'object') {
    //                 console.log(response.data);
    //                 setTotalRows(+response.data[0].totalcount)
    //                 setTableData(response.data.slice(1))
    //             }
    //             else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
    //         }
    //         setLoading(false)
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.code === "ERR_BAD_REQUEST") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //         setLoading(false)
    //     }
    // }


    async function fetchData(params: any = {}) {
        setLoading(true)
        console.log(Boolean(params['downloadcsv'] && params['downloadcsv'] != '0'));

        let downloadFile: boolean = Boolean(params['downloadcsv'] && params['downloadcsv'] != '0')
        if (!downloadFile) {
            params = { ...params, calculatetotalcount: true }
        }
        try {
            const response = await axios.get('https://cardgarantsales.com/restapi/transcript', {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow, maxRows },
                responseType: downloadFile ? 'blob' : 'json'
            })

            if (downloadFile) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount);
                    setTableData(response.data.slice(1));
                } else {
                    showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error');
                }
            }
            setLoading(false);

            if (downloadFile) {
                dispatch(onChangeConversationDetailFilter({ type: 'downloadcsv', value: '0' }))
                let updatedFilters = filters.map((el: any) => {
                    if (el.name == 'Download CSV') {
                        return {
                            ...el, params: [{
                                "type": "downloadcsv",
                                "label": "Download CSV",
                                "value": "0",
                                "input": "checkbox"
                            }]
                        }
                    }
                    else return el
                });

                localStorage.setItem(`conversationdetail_filter`, JSON.stringify(updatedFilters));
            }
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch);
            } else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false);
        }
    }

    //on load page send request to get table data with filters
    useEffect(() => {
        fetchData(uniqueid !== null ? { uniqueid: uniqueid } : getFilterValues(filters))
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filters])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);
    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={typeof (tableData) === 'object' ? tableData : []} page={'conversationdetail'} />, [tableData]);
    const memoizedFilter = useMemo(() => <Filter exclude={accesslevel !== "5" ? ['partnerbank'] : []} fetchData={(params: object) => fetchData(params)} page="conversationdetail" filtersList={ConversationDetailsFilterData} />, []);

    // Новый вспомогательный метод для добавления только новых объектов
    function mergeTableData(current: any[], incoming: any[], key: string = "id") {
        const existingIds = new Set(current.map(item => item[key]));
        const newItems = incoming.filter(item => !existingIds.has(item[key]));
        return [...newItems, ...current]; // новые элементы в начало
    }

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;

        const hasEndTime = (data: any[]) =>
            data.some((item) => item.endtime !== null && item.endtime !== "");

        if (uniqueid) {
            if (!hasEndTime(tableData)) {
                intervalId = setInterval(async () => {
                    try {
                        const response = await axios.get('https://cardgarantsales.com/restapi/transcript', {
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": "Bearer " + localStorage.getItem('access_token')
                            },
                            params: { uniqueid, startRow, maxRows, calculatetotalcount: true }
                        });
                        if (response.data && typeof response.data === 'object') {
                            // Добавляем только новые объекты
                            setTableData(prev => mergeTableData(prev, response.data.slice(1), "id")); // замените "id" на свой уникальный ключ
                            setTotalRows(+response.data[0].totalcount);
                        }
                    } catch (error) {
                        // обработка ошибок
                    }
                }, 2000);
            }
        }

        if (intervalId && hasEndTime(tableData)) {
            clearInterval(intervalId);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [uniqueid, tableData, startRow, maxRows]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column' }}>
            {memoizedFilter}
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            {/* {tableData.length != 0 && <AudioFragment id={tableData[0]['conversation']} type={'recordedconversation'} />} */}
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}